module.exports = __webpack_public_path__ + "img/icn_smudge.8c139e31.svg";